import { isValidElement } from 'react';
import {v4 as uuidv4} from 'uuid';

const CorporateData = [
    {
        id: uuidv4(),
        ques: ' Our Presence Across The Value Chain ',
        ans: `The world is changing all around us. To continue to thrive as a business over the next ten years and beyond, we must look ahead, understand the trends and forces that will shape our business in the future and move swiftly to prepare for what's to come. We must get ready for tomorrow today. That's what our 2020 Vision is all about. It creates a long-term destination for our business and provides us with a "Roadmap" for winning together with our bottling partners. `,
        miniDescription:"Our Roadmap starts with our mission, which is enduring. It declares our purpose as a company and serves as the standard against which we weigh our actions and decisions. ",
        ponitone:"To create value and make a difference. ",
        ponittwo:"Expertise in cotton industry ",

        ponitthree:"Social Responsibility ",
        
        
        
        smalldes:"Our vision serves as the framework for our Roadmap and guides every aspect of our business by describing what we need to accomplish in order to continue achieving sustainable, quality growth. ",
        index: 'faq1',
    },

    {
        id: uuidv4(),
        ques: 'Our Winning Culture ',
        ans: ' Our Winning Culture defines the attitudes and behaviors that will be required of us to make our 2020 Vision a reality.',
        index: 'faq2',
        miniDescription:" ",
        ponitone:"  ",
        ponittwo:"  ",
        ponitthree:"  ",
        ponitfour:"  ",
        ponitfive:"  ",
        ponitsix:"  ",
         
        smalldes:" ",
    },

    {
        id: uuidv4(),
        ques: 'Live Our Values ',
        ans: 'Our values serve as a compass for our actions and describe how we behave in the world.',
        index: 'faq3',
        miniDescription:"  ",
        ponitone:"Leadership: The courage to shape a better future ",
        ponittwo:"Collaboration: Leverage collective genius ",
        ponitthree:"Integrity: Be real   ",
        ponitfour:"Accountability: If it is to be, it's up to me  ",
        ponitfive:"Passion: Committed in heart and mind ",
        ponitsix:"Diversity: As inclusive as our brands Quality: What we do, we do well ",
        smalldes:"  ",
    },

    {
        id: uuidv4(),
        ques: 'Focus on the Market ',
        ans: '  ',
        index: 'faq4',
        ponitone:"Focus on needs of our consumers, customers and franchise partners ",
        ponittwo:"Get out into the market and listen, observe and learn",
        ponitthree:"Possess a world view ",
        ponitfour:"Focus on execution in the marketplace every day ",
        ponitfive:"Be insatiably curious",
        ponitsix:" ",
        smalldes:"  ",
    },

    {
        id: uuidv4(),
        ques: 'Work Smart ',
        ans: ' ',
        index: 'faq5',
        miniDescription:"",
        ponitone:"Act with urgency",
        ponittwo:"Remain responsive to change",
        ponitthree:"Have the courage to change course when needed ",
        ponitfour:"Remain constructively discontent",
        ponitfive:"Work efficiently",
        ponitsix:" ",
        smalldes:"  ",
    },
    {
        id: uuidv4(),
        ques: 'Act Like Owners  ',
        ans: '  ',
        index: 'faq6',
        miniDescription:"  ",
        ponitone:"Be accountable for our actions and inactions",
        ponittwo:"Steward system assets and focus on building value",
        ponitthree:"Reward our people for taking risks and finding better ways to solve problems",
        ponitfour:"Learn from our outcomes -- what worked and what didn’t",
        ponitfive:"",
        ponitsix:" ",
        smalldes:"  ",
    },
    {
        id: uuidv4(),
        ques: 'Be the Brand  ',
        ans: 'Inspire creativity, passion, optimism and fun',
        index: 'faq7',
        miniDescription:" ",
        ponitone:"  ",
        ponittwo:" ",
        ponitthree:" ",
        smalldes:"  ",
    },
     
]

export default CorporateData;